<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { DictList } from '@/request/index'
export default {
  name: 'App',
  created() {
    this.getDictAllLists()
  },
  methods: {
    //获取全部字典值
    getDictAllLists() {
      let that = this
      let params = { page: 0, size: 9999, }
      DictList(params).then(res => {
        // console.log("getDictAllLists",res.data.content)
        that.$store.commit('DISTALL', res.data.content) //改变用户信息
      })
    },
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue